export interface UpdateCurrentUserInput {
  username: string;
  firstName: string;
  lastName: string;
  timezone: string;
  emails: EmailInput[];
}

export interface EmailInput {
  emailAddress: string;
  emailType?: string;
  active: boolean;
  isDeleted?: boolean;
  isPrimary?: boolean;
  isVerified?: boolean;
}
